export const slotsAttributeHelper = (obj: Record<string, any>): string => {
  const str = Object.entries(obj)
    .filter(([key, value]) => value !== null && value !== undefined)
    .sort(([aKey, aValue], [bKey, bValue]) => aKey.localeCompare(bKey))
    .map(([key, value]) => {
      if (
        key === "popular" ||
        key === "recommended" ||
        key === "new" ||
        key === "all" ||
        key === "name"
      ) {
        return `${String(key).replace(/\s/g, "")}`;
      }
      return `${String(value).replace(/\s/g, "")}`;
    })
    .join("_");
  return str;
};
